import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './WorkOrderDetailsInfo.css';
import DetailsInfoItem from 'components/shared/details/DetailsInfoItem';
import BuildingDocumentsViewer from 'components/shared/document/BuildingDocumentsViewer';
import DetailsFilesContainer from 'components/shared/details/DetailsFilesContainer';
import Dropzone from 'react-dropzone';
import uploadPng from 'images/upload.png';
import FilesUploadedViewer from 'components/shared/files/FilesUploadedViewer';
import DocumentLink from 'components/shared/document/DocumentLink';
import DetailsInfo from 'components/shared/details/DetailsInfo';
import { getCurrentWorkOrder } from 'selectors/admin/work-orders/work-orders';
import { TYPES, usersUtil } from 'services/utils/users-util';
import { getCurrentUser } from 'selectors/authentication';
import {
  getWorkOrderNoteEdit,
  getWorkOrderNoteReminderValue,
  getWorkOrderNoteSaving,
  getWorkOrderNoteValue,
} from 'selectors/admin/work-orders/details/details';
import {
  changeWorkOrderNote,
  changeWorkOrderNoteReminder,
  editWorkOrderNote,
  removeDocumentRequest,
  saveWorkOrderNoteRequest,
  uploadDocumentsRequest,
} from 'actions/admin/work-orders/details/details';
import numeral from 'numeral';
import Number from 'components/shared/text/Number';
import { timeSelector } from 'components/admin/work-orders/details/time/store/selectors';
import { vendorInvoicesSelector } from 'components/admin/work-orders/details/vendor-invoices/store/selectors';
import { receiptsSelector } from 'components/admin/work-orders/details/receipts/store/selectors';
import NoteEditor from 'components/shared/NoteEditor';

class WorkOrderDetailsInfo extends Component {
  static propTypes = {
    currentWorkOrder: PropTypes.shape({}).isRequired,
    materials: PropTypes.array.isRequired,
    time: PropTypes.array.isRequired,
    vendorInvoices: PropTypes.array.isRequired,
    workOrderNoteEdit: PropTypes.bool.isRequired,
    workOrderNoteSaving: PropTypes.bool.isRequired,
    workOrderNoteValue: PropTypes.string.isRequired,
    workOrderNoteReminderValue: PropTypes.string,
    onDocumentsDrop: PropTypes.func.isRequired,
    onDocumentRemove: PropTypes.func.isRequired,
    onNoteChange: PropTypes.func.isRequired,
    onNoteEdit: PropTypes.func.isRequired,
    onNoteReminderChange: PropTypes.func.isRequired,
    onNoteSave: PropTypes.func.isRequired,
  };

  static defaultProps = {
    workOrderNoteReminderValue: null,
  };

  constructor(props) {
    super(props);
    const { currentUser } = this.props;
    this.userIsAdmin =
      usersUtil.isAdmin(currentUser) ||
      usersUtil.hasType(currentUser, TYPES.GENERAL_CONTRACTOR);
    this.userIsContractor = usersUtil.hasType(currentUser, TYPES.CONTRACTOR);
  }

  handleDocumentsDrop = (documents) => {
    this.props.onDocumentsDrop(this.props.currentWorkOrder.id, documents);
  };

  handleDocumentRemove = (documentId) => {
    this.props.onDocumentRemove(this.props.currentWorkOrder.id, documentId);
  };

  handleWorkOrderNoteChange = (value) => {
    this.props.onNoteChange(value);
  };

  handleWorkOrderNoteEdit = () => {
    this.props.onNoteEdit(true);
  };

  handleWorkOrderNoteReminderChange = (value) => {
    this.props.onNoteReminderChange(value);
  };

  handleWorkOrderNoteSave = () => {
    this.props.onNoteSave(
      this.props.currentWorkOrder.id,
      this.props.workOrderNoteValue,
      this.props.workOrderNoteReminderValue
    );
  };

  renderCostsSummary = () => {
    const { materials, time, vendorInvoices } = this.props;
    const show =
      materials.length > 0 || time.length > 0 || vendorInvoices.length > 0;
    if (show) {
      const materialsTotal = materials.reduce((total, material) => {
        return total + numeral(material.cost).value();
      }, 0);
      const timeTotal = time.reduce((total, entry) => {
        return total + (entry.cost !== null ? numeral(entry.cost).value() : 0);
      }, 0);
      const vendorInvoicesTotal = vendorInvoices.reduce(
        (total, vendorInvoice) => {
          return total + numeral(vendorInvoice.cost).value();
        },
        0
      );
      const lines = [];
      let total = 0;
      if (materialsTotal > 0) {
        lines.push(
          <div className="costs-summary-row">
            <div>Materials:</div>
            <div>
              <Number value={materialsTotal} format="$0,0.[00]" />
            </div>
          </div>
        );
        total += materialsTotal;
      }
      if (timeTotal > 0) {
        lines.push(
          <div className="costs-summary-row">
            <div>Labor:</div>
            <div>
              <Number value={timeTotal} format="$0,0.[00]" />
            </div>
          </div>
        );
        total += timeTotal;
      }
      if (vendorInvoicesTotal > 0) {
        lines.push(
          <div className="costs-summary-row">
            <div>Vendor:</div>
            <div>
              <Number value={vendorInvoicesTotal} format="$0,0.[00]" />
            </div>
          </div>
        );
        total += vendorInvoicesTotal;
      }
      if (total > 0) {
        lines.push(
          <div className="costs-summary-row">
            <div className="costs-summary-total">Total:</div>
            <div>
              <Number value={total} format="$0,0.[00]" />
            </div>
          </div>
        );
      }
      return <DetailsInfoItem lines={lines} title="COSTS SUMMARY" />;
    }
    return null;
  };

  render() {
    const {
      currentWorkOrder,
      currentWorkOrder: { general_contractor },
    } = this.props;
    return (
      <div className="work-order-details-info">
        <DetailsInfo
          itemsLines={[
            [
              <DetailsInfoItem
                lines={[
                  currentWorkOrder.building.location.street_address_1,
                  currentWorkOrder.building.location.city +
                    ', ' +
                    currentWorkOrder.building.location.state +
                    ' ' +
                    currentWorkOrder.building.location.zip,
                  currentWorkOrder.building.name !== '' &&
                  currentWorkOrder.building.name !== null
                    ? currentWorkOrder.building.name
                    : '',
                ]}
                title="BUILDING"
              />,
              general_contractor && (
                <DetailsInfoItem
                  lines={[general_contractor.name]}
                  title="GENERAL CONTRACTOR"
                />
              ),
              <DetailsInfoItem
                lines={currentWorkOrder.working_hours}
                title="AVAILABLE WORKING HOURS"
              />,
            ]
              .concat(
                // Show subcontractors only if available in WO
                currentWorkOrder.propietary_sub_contractors !== undefined ? (
                  <DetailsInfoItem
                    lines={
                      currentWorkOrder.propietary_sub_contractors.length > 0
                        ? currentWorkOrder.propietary_sub_contractors.map(
                            (element) => {
                              return element.name;
                            }
                          )
                        : [
                            currentWorkOrder.dont_know_subcons
                              ? "Don't know"
                              : 'No',
                          ]
                    }
                    title="PROPRIETARY SUBCONTRACTORS"
                  />
                ) : (
                  []
                )
              )
              .concat(
                this.userIsAdmin ? (
                  <div className="work-order-note-editor-container">
                    <div>
                      <NoteEditor
                        canEdit={this.userIsAdmin}
                        edit={this.props.workOrderNoteEdit}
                        label="notes"
                        reminderLabel="reminder date"
                        saving={this.props.workOrderNoteSaving}
                        value={this.props.workOrderNoteValue}
                        reminderValue={this.props.workOrderNoteReminderValue}
                        reminderOriginalValue={
                          currentWorkOrder.note_reminder_date
                        }
                        onEdit={this.handleWorkOrderNoteEdit}
                        onSave={this.handleWorkOrderNoteSave}
                        onValueChange={this.handleWorkOrderNoteChange}
                        onReminderValueChange={
                          this.handleWorkOrderNoteReminderChange
                        }
                      />
                    </div>
                  </div>
                ) : (
                  []
                )
              )
              .concat(this.userIsContractor ? this.renderCostsSummary() : []),
          ]}
          rightContainer={
            <div className="requirements-container">
              <BuildingDocumentsViewer
                documents={currentWorkOrder.building.documents}
              />

              <DetailsFilesContainer header="My Documents">
                <div className="dropzone-container">
                  <Dropzone
                    accept="application/pdf, .doc, .docx, .xls, .xlsx"
                    className="building-files-dropzone"
                    onDrop={this.handleDocumentsDrop}
                  >
                    <span>Please drag and drop any file into this area</span>
                    <img src={uploadPng} alt="remove" />
                  </Dropzone>
                </div>

                <div className="files-viewer">
                  <FilesUploadedViewer
                    documents={currentWorkOrder.documents}
                    showLink={true}
                    onDocumentRemove={this.handleDocumentRemove}
                  />
                </div>
              </DetailsFilesContainer>

              <DetailsFilesContainer
                header="Other Documents"
                show={currentWorkOrder.other_documents.length > 0}
              >
                {currentWorkOrder.other_documents.map((document, index) => {
                  return (
                    <DocumentLink key={index} url={document.document.url} />
                  );
                })}
              </DetailsFilesContainer>
            </div>
          }
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: getCurrentUser(state),
    currentWorkOrder: getCurrentWorkOrder(state),
    materials: receiptsSelector(state),
    time: timeSelector(state),
    vendorInvoices: vendorInvoicesSelector(state),
    workOrderNoteEdit: getWorkOrderNoteEdit(state),
    workOrderNoteSaving: getWorkOrderNoteSaving(state),
    workOrderNoteValue: getWorkOrderNoteValue(state),
    workOrderNoteReminderValue: getWorkOrderNoteReminderValue(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  onDocumentsDrop: (workOrderId, documents) => {
    dispatch(uploadDocumentsRequest(workOrderId, documents));
  },
  onDocumentRemove: (workOrderId, documentId) => {
    dispatch(removeDocumentRequest(workOrderId, documentId));
  },
  onNoteChange: (value) => {
    dispatch(changeWorkOrderNote(value));
  },
  onNoteEdit: (value) => {
    dispatch(editWorkOrderNote(value));
  },
  onNoteReminderChange: (value) => {
    dispatch(changeWorkOrderNoteReminder(value));
  },
  onNoteSave: (workOrderId, noteValue, noteReminerValue) => {
    dispatch(
      saveWorkOrderNoteRequest(workOrderId, noteValue, noteReminerValue)
    );
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WorkOrderDetailsInfo);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/WorkOrderDetailsInfo.js